export default __webpack_public_path__ + "static/media/KOD0135-min.737b8ffd.webp";